const KEYFRAMES = `
  @keyframes pageLoaderFadeIn  { from { opacity: 0 } to { opacity: 1 } }
  @keyframes pageLoaderFadeOut { from { opacity: 1 } to { opacity: 0 } }
`;

interface PageLoaderProps {
  fadingOut?: boolean;
}

const PageLoader = ({fadingOut = false}: PageLoaderProps): JSX.Element => (
  <>
    <style>{KEYFRAMES}</style>
    <div
      style={{
        position: 'absolute',
        inset: 0,
        minHeight: '100vh',
        zIndex: 10,
        background: 'white',
        animation: fadingOut
          ? 'pageLoaderFadeOut 0.35s ease-out forwards'
          : 'pageLoaderFadeIn 0.25s ease-out',
      }}
    >
      <div
        style={{
          position: 'sticky',
          top: 0,
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src="/media/logos/LOGO_CELESTE_Sans_Baseline_Bleu.png"
          alt="Celeste"
          style={{width: 200, marginBottom: 32}}
        />
        <div
          className="spinner-border text-primary"
          role="status"
          style={{width: '2.5rem', height: '2.5rem'}}
        >
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    </div>
  </>
);

export default PageLoader;
